import TutorialsListPage from './components/TutorialsListPage'

export default TutorialsListPage
